import { ButtonOutline } from '@lambdacurry/component-library';
import { Link } from 'gatsby';
import { Card, CardContent } from 'lib/components';
import { useUnpauseSubscriptionMutation } from 'lib/home/generated/queries';
import { useQueryClient } from 'react-query';
import { OrdersQuery } from 'lib/home/generated/types/api';

interface CurrentOrderPausedProps {
  reason?: string;
}

export const CurrentOrderPaused = ({ reason }: CurrentOrderPausedProps) => {
  const queryClient = useQueryClient();

  const { mutate } = useUnpauseSubscriptionMutation({
    onSuccess: ({ unpauseSubscription }) => {
      queryClient.setQueryData(['Orders'], (query: OrdersQuery) => {
        query.me.subscription = unpauseSubscription;
        return query;
      });
    }
  });

  return (
    <Card className="current-order-paused-box bg-brand-dark-green-500 text-white z-10 max-w-xsf md:max-w-md lg:max-w-lg">
      <CardContent>
        <h3>Your subscription is currently paused.</h3>
        {reason?.startsWith('payment_failed_') && (
          <p>
            Your subscription paused due to an error with your payment method, please update the default payment method
            in your <Link to="/account/payment-methods">account settings</Link>
          </p>
        )}
        <ButtonOutline className="!text-white mt-4" onClick={() => mutate({})}>
          Unpause your subscription
        </ButtonOutline>
      </CardContent>
    </Card>
  );
};
